/* Multi-Solar beweging (gekozen door Moes 24-09-2026): scroll-onthulling, tellers,
   reviews-autoplay, wagen-wip. Geen urgentie, geen timers; alles stopt bij prefers-reduced-motion. */
(() => {
  const rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll-onthulling: kaarten en koppen komen zacht omhoog in beeld, gespreid per rij. */
  const onthulSelector = [
    '.mts-sectiekop', '.mts-tegels > li', '.mts-cats > li', '.mts-usps > li', 
    '.mts-cijfers > li', '.mts-faq__item', '.mts-contactregel', '.mts-merken__kop'
  ].join(',');

  const onthul = () => {
    const elementen = document.querySelectorAll(onthulSelector);
    if (!elementen.length) return;
    if (rustig || !('IntersectionObserver' in window)) return;

    elementen.forEach((el) => {
      const ouder = el.parentElement;
      const index = ouder ? Array.prototype.indexOf.call(ouder.children, el) : 0;
      el.style.setProperty('--mts-vertraging', `${Math.min(index, 7) * 70}ms`);
      el.classList.add('mts-reveal');
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-zichtbaar');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    elementen.forEach((el) => io.observe(el));
  };

  /* 2. Tellers: "2.000+" telt op van 0 zodra hij in beeld komt. */
  const tellers = () => {
    const waarden = document.querySelectorAll('.mts-cijfer__waarde');
    if (!waarden.length) return;

    const formatteer = (n, decimalen) => {
      const vast = n.toFixed(decimalen);
      const [heel, rest] = vast.split('.');
      const metPunten = heel.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return rest ? `${metPunten},${rest}` : metPunten;
    };

    const start = (el) => {
      const tekst = el.textContent.trim();
      const m = tekst.match(/^([^\d]*)([\d.]+(?:,\d+)?)(.*)$/);
      if (!m) return;
      const [, voor, getal, na] = m;
      const decimalen = (getal.split(',')[1] || '').length;
      const doel = parseFloat(getal.replace(/\./g, '').replace(',', '.'));
      if (!isFinite(doel)) return;
      const duur = 1200;
      const t0 = performance.now();
      const stap = (t) => {
        const p = Math.min(1, (t - t0) / duur);
        const e = 1 - Math.pow(1 - p, 3);
        el.textContent = `${voor}${formatteer(doel * e, decimalen)}${na}`;
        if (p < 1) requestAnimationFrame(stap);
        else el.textContent = tekst;
      };
      requestAnimationFrame(stap);
    };

    if (rustig || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        start(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    waarden.forEach((el) => io.observe(el));
  };

  /* 4. Reviews: elke 6 s precies één kaart verder (op de kaartrand), terug naar het begin na de laatste.
        Stopt zodra je erover hangt of erin tikt. */
  const reviews = () => {
    document.querySelectorAll('.mts-reviews__slider').forEach((slider) => {
      const lijst = slider.querySelector('[id^="Slider-"]');
      const kaarten = lijst ? [...lijst.querySelectorAll('.slider__slide')] : [];
      if (!lijst || kaarten.length < 2 || rustig) return;
      let pauze = false;
      const zetPauze = (v) => () => { pauze = v; };
      slider.addEventListener('mouseenter', zetPauze(true));
      slider.addEventListener('mouseleave', zetPauze(false));
      slider.addEventListener('focusin', zetPauze(true));
      slider.addEventListener('focusout', zetPauze(false));
      slider.addEventListener('touchstart', zetPauze(true), { passive: true });
      slider.addEventListener('pointerdown', zetPauze(true));
      const naar = (i) => {
        const doel = kaarten[i];
        lijst.scrollTo({ left: doel.offsetLeft - lijst.offsetLeft, behavior: 'smooth' });
      };
      setInterval(() => {
        if (pauze || document.hidden) return;
        const breedte = kaarten[1].offsetLeft - kaarten[0].offsetLeft || 1;
        const huidig = Math.round(lijst.scrollLeft / breedte);
        naar((huidig + 1) % kaarten.length);
      }, 6000);
    });
  };

  /* 5. Winkelwagen-pill wipt kort als de inhoud verandert (na toevoegen). */
  const wagen = () => {
    const pill = document.getElementById('cart-icon-bubble');
    if (!pill || rustig || !('MutationObserver' in window)) return;
    let eerste = true;
    new MutationObserver(() => {
      if (eerste) { eerste = false; }
      pill.classList.remove('mts-wagen--wip');
      void pill.offsetWidth;
      pill.classList.add('mts-wagen--wip');
      setTimeout(() => pill.classList.remove('mts-wagen--wip'), 700);
    }).observe(pill, { childList: true });
  };

  const start = () => { onthul(); tellers(); reviews(); wagen(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
